import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateChoices',
})
export class TranslateChoicesPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    if (!value) {
      return value;
    }

    const pattern = /{{\s*'((?:[^']|'(?!\s*}}))+)'\s*}}/g;

    return value.replace(pattern, (match, key) => {
      const translatedValue = this.translate.instant(key);
      return translatedValue !== key ? translatedValue : key;
    });
  }
}
